module.exports = __webpack_public_path__ + "static/easycompany-ca8fecc232beb813278e6375953a4728.svg";